import { Search } from "@mui/icons-material";
import { StandardTextFieldProps, TextFieldProps } from "@mui/material";
import { useMemo } from "react";

import { InputAdornment } from "@/Components/v2/atoms/InputAdornment";
import { TextField } from "@/Components/v2/atoms/TextField";
import { Typography } from "@/Components/v2/atoms/Typography";

// Constants
export const SELECT_ALL = "select-all";

export const SelectLabel = ({ label }: { label: string }) => (
  <Typography variant="body1" mb={1} fontWeight={600}>
    {label}
  </Typography>
);

// Define proper types for TextField props
type CustomTextFieldProps = StandardTextFieldProps & {
  InputProps?: TextFieldProps["InputProps"];
};

export interface RenderInputProps extends Omit<CustomTextFieldProps, "value"> {
  id: string;
  label: string;
  disabled?: boolean;
  placeholder?: string;
  value: string | string[] | null;
  selectedLabel?: string | undefined;
  placeholderOverride?: string;
}

export const RenderInput = ({
  id,
  label,
  disabled = false,
  value,
  selectedLabel,
  placeholderOverride,
  ...params
}: RenderInputProps) => {
  const placeholder = useMemo(() => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return placeholderOverride ? placeholderOverride : `Select ${label}`;
    }
    return "";
  }, [value, label, placeholderOverride]);

  return (
    <TextField
      {...params}
      id={id}
      InputProps={{
        ...params.InputProps,
        startAdornment: (
          <>
            <Search />
            {selectedLabel && (
              <InputAdornment position="end">
                <Typography>{selectedLabel}</Typography>
              </InputAdornment>
            )}
          </>
        ),
      }}
      placeholder={placeholder}
      disabled={disabled}
      fullWidth
      size="small"
    />
  );
};
